import styled from 'styled-components'

export const CircleContainer = styled.div`
  text-align: center;
`

export const Wrapper = styled.div`
  display: inline-block;
  position: relative;
`

export const Circle = styled.div`
  border-radius: 100%;
  width: ${p => p.theme.blocks.circleSizeSmall};
  height: ${p => p.theme.blocks.circleSizeSmall};
  background: ${p => p.theme.colors.lilac};
`

export const CircleIcon = styled.div`
  height: ${p => p.iconH};
  width: ${p => p.iconW};
  left: ${p => p.iconLeft};
  top: ${p => p.iconTop};
  bottom: ${p => p.iconBottom};
  position: absolute;
  pointer-events: none;
`
export const Description = styled.div`
  color: white;
`
